var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('Messages'),_c('Activities'),_c('ActiveVisitsMap')],1),_c('div',{staticClass:"row mt-2"},[_c('Orders'),_c('Visits')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }